var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("breadcrumb"),
      _vm._v(" "),
      _c("agency-lead-modal"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container agency mt-2 mb-4",
          attrs: { id: "agencymap" }
        },
        [
          _c("h1", [
            _vm._v(
              _vm._s(
                _vm.lang.title
                  .replace(
                    ":network",
                    _vm.$root.network[0].toUpperCase() +
                      _vm.$root.network.slice(1)
                  )
                  .replace(":district", _vm.agency.district)
                  .replace(":city", _vm.agency.city.title)
                  .replace(":province", _vm.agency.province.title)
                  .replace(
                    ":region",
                    _vm.agency.region.id != 1 ? _vm.agency.region.title : ""
                  )
              )
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm._t("header"),
              _vm._v(" "),
              _c("div", { staticClass: "agency-card" }, [
                _c(
                  "div",
                  { staticClass: "agency-data align-items-center pt-0" },
                  [
                    _c("img", {
                      attrs: {
                        src: "/img/icons/icon-" + _vm.agency.network + ".svg",
                        alt: _vm.agency.network,
                        width: "38",
                        height: "35"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "agency-heading-data" }, [
                      _c("div", { staticClass: "business-name" }, [
                        _c("span", { staticClass: "affiliate-label" }, [
                          _vm._v(_vm._s(_vm.lang.labels.affiliate) + ":")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.agency.name) +
                            "\n                            "
                        ),
                        _vm.agency.aicat
                          ? _c("img", {
                              staticClass: "agency-aicat-img",
                              attrs: { src: _vm.agency.aicat }
                            })
                          : _vm._e()
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center ml-auto fixflex" },
                  [
                    _c("div", { staticClass: "links-container" }, [
                      _vm.agency.url_facebook
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-contact mr-1",
                              attrs: {
                                href: _vm.agency.url_facebook,
                                target: "_blank",
                                rel: "noopener"
                              }
                            },
                            [
                              _c("masked-image", {
                                attrs: { src: "/img/icons/facebook-big.svg" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.agency.url_instagram
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-contact mr-1",
                              attrs: {
                                href: _vm.agency.url_instagram,
                                target: "_blank",
                                rel: "noopener"
                              }
                            },
                            [
                              _c("masked-image", {
                                attrs: { src: "/img/icons/instagram-big.svg" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.agency.url_linkedin
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-contact mr-1",
                              attrs: {
                                href: _vm.agency.url_linkedin,
                                target: "_blank",
                                rel: "noopener"
                              }
                            },
                            [
                              _c("masked-image", {
                                attrs: { src: "/img/icons/linkedin-big.svg" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.agency.url_twitter
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-contact mr-1",
                              attrs: {
                                href: _vm.agency.url_twitter,
                                target: "_blank",
                                rel: "noopener"
                              }
                            },
                            [
                              _c("masked-image", {
                                attrs: { src: "/img/icons/twitter-big.svg" }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", {}, [
                      _vm.agency.active && _vm.agency.url_agency
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-network",
                              attrs: {
                                href: _vm.agency.url_agency,
                                target: "_blank",
                                rel: "noopener"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.lang.labels.homepage))
                              ])
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "agency-card mt-3 d-block" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-xl-4 col-md-4 agency-img-zone" },
                    [
                      _vm.agency.url_image
                        ? _c("img", {
                            attrs: { src: _vm.agency.url_image, width: "100%" }
                          })
                        : _c("img", {
                            attrs: { src: "/img/img-agency.svg", width: "100%" }
                          })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-xl-3 col-md-8 agency-data-img" },
                    [
                      _c("div", { staticClass: "info" }, [
                        _c("h3", [_vm._v(_vm._s(_vm.lang.labels.place))]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-start mb-1" },
                          [
                            _c(
                              "div",
                              { staticClass: "p-2" },
                              [
                                _c("masked-image", {
                                  staticClass: "ico_map",
                                  attrs: { src: "/img/icons/map.svg" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.agency.address) + " ")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.agency.opening_hours
                          ? _c("div", [
                              _c("h3", [_vm._v(_vm._s(_vm.lang.labels.hours))]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-start mb-1"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "p-2" },
                                    [
                                      _c("masked-image", {
                                        staticClass: "ico_hours",
                                        attrs: { src: "/img/icons/hours.svg" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "hours_scroll" }, [
                                    _vm._v(_vm._s(_vm.agency.opening_hours))
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("h3", [_vm._v(_vm._s(_vm.lang.labels.contacts))]),
                        _vm._v(" "),
                        _vm.agency.status == "ATTIVO" ||
                        _vm.agency.status == "PRE_SOSPESO"
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "p-2" },
                                    [
                                      _c("masked-image", {
                                        attrs: { src: "/img/icons/email.svg" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "email" }, [
                                    _vm._v(_vm._s(_vm.agency.email))
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.agency.whatsapp
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "p-2" },
                                    [
                                      _c("masked-image", {
                                        attrs: {
                                          src: "/img/icons/ico_whatsapp.svg"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "whatsapp" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "https://wa.me/" +
                                            this.agency.whatsapp,
                                          target: "_blank"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.agency.whatsapp))]
                                    )
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.agency.phone
                          ? _c("div", { staticClass: "phone-map" }, [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "p-2" },
                                    [
                                      _c("masked-image", {
                                        staticStyle: { width: "1rem" },
                                        attrs: {
                                          src: "/img/icons/phone-agency.svg",
                                          alt: _vm.agency.phone
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "phone" }, [
                                    _vm._v(_vm._s(_vm.agency.phone))
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.agency.active
                    ? _c("div", { staticClass: "col-xl-5" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "banner view-properties mb-1 d-flex justify-content-between"
                          },
                          [
                            _c("div", { staticClass: "w-50 null" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "w-50" }, [
                              _c("div", { staticClass: "p-1 title" }, [
                                _vm._v(_vm._s(_vm.lang.site.title))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-1" }, [
                                _vm._v(_vm._s(_vm.lang.site.intro))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-auto p-1" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.agency.url_agency,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.lang.site.link))]
                                )
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "banner sell-properties d-flex justify-content-between"
                          },
                          [
                            _c("div", { staticClass: "w-50 null" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "w-50" }, [
                              _c("div", { staticClass: "p-1 title" }, [
                                _vm._v(_vm._s(_vm.lang.evaluations.title))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "p-1" }, [
                                _vm._v(_vm._s(_vm.lang.evaluations.intro))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-auto p-1" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        _vm.agency.url_agency +
                                        _vm.config.url.evaluations,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.lang.evaluations.link))]
                                )
                              ])
                            ])
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _vm.isActive
            ? _c("agency-map", {
                attrs: {
                  latitude: _vm.agency.latitude,
                  longitude: _vm.agency.longitude,
                  network: _vm.agency.network,
                  sector: _vm.agency.sector,
                  "tecnomaps-endpoint": _vm.tecnomapEndpoint,
                  marker: _vm.marker
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.agency.team
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "agency-team" },
                  [
                    _c("h4", { staticClass: "agency-team-title" }, [
                      _c("img", {
                        attrs: { src: "/img/icons/agency-team.svg" }
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.lang.labels.team) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("agency-team-carousel", {
                      attrs: { team: _vm.agency.team }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots.description
            ? _c(
                "div",
                { staticClass: "desc-card" },
                [
                  _c("h4", { staticClass: "agency-team-title" }, [
                    _c("img", { attrs: { src: "/img/icons/agency-team.svg" } }),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.lang.labels.description) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _vm._t("description")
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }